<template>
    <div>
        <span
            class="edit-box"
            :id="textEditId"
            v-html="note"
            :style="note.length === 0 ? { color: '#da4e4e'} : {}"
            @input="textEdited"
            contenteditable="true"></span>
    </div>
</template>

<script>
export default {
    name: 'text-edit',

    props: {
        value: {
            type: String
        },
        textEditId: {
            type: String
        }
    },

    data() {
        return {
            note: this.value,
            myCurrElem: null
        }
    },

    mounted() {
        document.addEventListener('mousedown', this.onSelectFunct2);
    },

    beforeDestroy() {
        document.removeEventListener('mousedown', this.onSelectFunct2)
    },

    methods: {
        textEdited($event) {
            this.$emit('input', $event.target.innerHTML)
        },

        onSelectFunct(e) {
            return
            const currElem = e.target
                if((currElem.id == this.textEditId || currElem.closest('#'+this.textEditId) !== null) && window.getSelection().toString().trim() !== '') {
                    const copiedText = window.getSelection().toString().trim()
                    this.myCurrElem.removeEventListener('mouseup', this.onSelectFunct)
                    this.$emit('text-selected', copiedText, this.textEditId, false)
                } 
                else {
                    this.myCurrElem.removeEventListener('mouseup', this.onSelectFunct)
                    this.$emit('text-selected', null, this.textEditId, false)
                }
        },
        onSelectFunct2(e) {
            return
            this.myCurrElem = document.getElementById(this.textEditId)
            const myCurrElemTrgt = e.target
            if(myCurrElemTrgt.id == this.textEditId || myCurrElemTrgt.closest('#'+this.textEditId) !== null) {
                this.myCurrElem.addEventListener('mouseup', this.onSelectFunct)
            } else if(e.target.closest('.el-dropdown-menu') || e.target.closest('.cust-pop-class') || e.target.closest('.send-now-modal')) {
                this.$emit('text-selected', null, this.textEditId, false)
            } else {
                this.$emit('text-selected', null, this.textEditId, true)
            }
        }
    }
}
</script>

<style>
.edit-box {
    outline: none;
    padding: 12px 20px;
    display: block;
}
</style>
